namespace Matrix.DataAudit {
    export interface SecurityHistoryListRequest extends Serenity.ListRequest {
        ViewUnion?: boolean;
        StartDate?: string;
        EndDate?: string;
    }
}
